import React from "react";
import { useBnbSelector } from "../../../redux/store";
import { BnbLabel, useBnbOptionalLabel } from "../../../utils/labels";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import ETADeliveryLabel from "../common/ETADeliveryLabel";
import Price from "../common/price/Price";
import type { AlternativesETAModalType } from "../../../utils/modalConstants";
import * as Modal from "../../../../../../common-deprecated/styles/v2/toyota/globals/Modal";
import * as Flex from "../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as Type from "../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import * as Button from "../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Styles from "./styles/AlternativesETAModal";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { ImageFluid } from "../../../../../../common-deprecated/styles/v2/toyota/globals/Image";
import { trackEtaOpenSelect } from "../../../utils/tracking";
import { getEtaAlternativeUrl } from "../../../utils/typedUtils";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";
import { useCommonLabel } from "../../../../../../common-deprecated/utils/commonLabels";
import ButtonPrimary from "../../../../../../common-deprecated/components/aem/toyota/ButtonPrimary";

const AlternativesETAModal = (props: ModalViewType<AlternativesETAModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const { alternatives } = useBnbSelector((state) => state.eta);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const urlStockCarsLandingPage = useBnbSelector((state) => state.bnbSettings.urlStockCarsLandingPage);
    const [viewStockCarsLabel, viewStockCarsDescriptionLabel] = useBnbOptionalLabel([
        "viewStockCars",
        "viewStockCarsDescription",
    ]);

    const closeLabel = useCommonLabel("close");

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="lg">
            <Modal.Header>
                <Modal.Title>
                    <BnbLabel label="alternatives" />
                </Modal.Title>
                <Modal.Button type="button" aria-label={closeLabel} onClick={close}>
                    <IconWrapper>
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body>
                <Flex.Row>
                    {alternatives.map((car) => (
                        <Flex.Col
                            display="flex"
                            flex="1 1 auto"
                            width={{ _: 1, md: 1 / 2 }}
                            mb={{ _: 2, lg: 4 }}
                            key={`${car.id}-${car.colour.internalCode || car.colour.code}-${
                                car.upholstery.internalCode
                            }`}
                        >
                            <Styles.CarWrapper
                                key={`${car.id}-${car.colour.internalCode || car.colour.code}-${
                                    car.upholstery.internalCode
                                }`}
                            >
                                <ETADeliveryLabel date={(car.eta && car.eta.date) || ""} />
                                <Type.H2 headingType="gamma" mt={1} mb={1}>
                                    {car.grade.name}
                                </Type.H2>
                                <Type.SmallText as="div" color="grey4">
                                    {car.body.name} - {car.motorization.engine.name} -{" "}
                                    {car.motorization.transmission.name}
                                </Type.SmallText>
                                <Styles.PriceContainer>
                                    {/* Div needed for mobile layout */}
                                    <Price price={car.price} financeInfo={car.financeInfo} />
                                </Styles.PriceContainer>
                                <ImageFluid
                                    src={car.carImage}
                                    alt={`${car.model.name} ${car.body.name} ${car.grade.name} ${car.motorization.engine.name} ${car.motorization.transmission.name}`}
                                />
                                <ButtonPrimary
                                    fullWidth
                                    onClick={() => {
                                        trackEtaOpenSelect();
                                        window.location.href = getEtaAlternativeUrl(commonSettings, car);
                                    }}
                                >
                                    <BnbLabel label="chooseThisGrade" />
                                </ButtonPrimary>
                            </Styles.CarWrapper>
                        </Flex.Col>
                    ))}
                </Flex.Row>
                {!!urlStockCarsLandingPage && !!viewStockCarsLabel && (
                    <Flex.Col width={{ xs: 1 }} justifyContent="center" display="flex" mt={5}>
                        <Styles.CTAContainer width={{ xs: 1, sm: 1 / 4 }}>
                            {!!viewStockCarsDescriptionLabel && (
                                <Type.Text headingType="base">{viewStockCarsDescriptionLabel}</Type.Text>
                            )}
                            <Button.Secondary as="a" m={0} display="block" href={urlStockCarsLandingPage}>
                                {viewStockCarsLabel}
                            </Button.Secondary>
                        </Styles.CTAContainer>
                    </Flex.Col>
                )}
            </Modal.Body>
        </ModalBaseView>
    );
};

export default AlternativesETAModal;
